import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocationOff as LocationOffIcon } from '@mui/icons-material';
import MapZoomWrapper from './MapZoomWrapper';
import { Vyjezd2026CasovkaOverlay } from './Vyjezd2026CasovkaOverlay';
import type { Udalost } from '../api/JsdhNotifikaceService/generated/models/Udalost';
import type { MapConfig, MapaLayout } from '../api/JsdhNotifikaceService/generated/models/DeviceToken';
import type { UdalostRouteResponse } from '../api/JsdhNotifikaceService/generated/models/UdalostRoute';

interface Vyjezd2026MapaSectionProps {
    aktivniPoplach: Udalost;
    mapConfig?: MapConfig;
    mapaLayout: MapaLayout;
    routeData: UdalostRouteResponse | null;
    stationGps?: string;
    casVyjezdMinuty: number;
}

export const Vyjezd2026MapaSection: React.FC<Vyjezd2026MapaSectionProps> = ({
    aktivniPoplach, mapConfig, mapaLayout, routeData, stationGps, casVyjezdMinuty,
}) => {
    const hasRoute = !!routeData?.polyline && routeData.polyline.length > 0;
    const hasGps = !!aktivniPoplach.gps;
    let effective: MapaLayout = mapaLayout;
    if ((effective === 'misto-trasa' || effective === 'trasa') && !hasRoute) effective = 'misto';

    if (effective === 'off' || !hasGps) {
        return (
            <Box sx={{
                flex: 1, position: 'relative', bgcolor: 'background.default',
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                gap: 1.5,
            }}>
                <LocationOffIcon sx={{ fontSize: 96, color: 'text.disabled' }} />
                <Typography sx={{ fontSize: '1.5rem', fontWeight: 700, color: 'text.secondary' }}>
                    Mapa není k dispozici
                </Typography>
                <Typography sx={{ fontSize: '1rem', color: 'text.disabled', textAlign: 'center', px: 2 }}>
                    {effective === 'off' ? 'Mapa je vypnutá v konfiguraci.' : 'Pro tento poplach nejsou dostupné GPS souřadnice.'}
                </Typography>
                {aktivniPoplach.casVyhlaseni && (
                    <Vyjezd2026CasovkaOverlay
                        casVyhlaseni={aktivniPoplach.casVyhlaseni}
                        casVyjezdMinuty={casVyjezdMinuty}
                    />
                )}
            </Box>
        );
    }

    return (
        <Box sx={{ flex: 1, position: 'relative', display: 'flex', minHeight: 0 }}>
            {(effective === 'misto' || effective === 'misto-trasa') && (
                <Box sx={{ flex: 1, minHeight: 0 }}>
                    <MapZoomWrapper
                        gps={aktivniPoplach.gps}
                        hasCisloPopisne={!!aktivniPoplach.cisloPopisne}
                        showHyndrant={aktivniPoplach.pred === 'POŽÁR'}
                        height="100%"
                        mapConfig={mapConfig}
                    />
                </Box>
            )}
            {(effective === 'trasa' || effective === 'misto-trasa') && hasRoute && (
                <Box sx={{ flex: 1, minHeight: 0, ...(effective === 'misto-trasa' && { pl: '2px' }) }}>
                    <MapZoomWrapper
                        gps={aktivniPoplach.gps}
                        hasCisloPopisne={!!aktivniPoplach.cisloPopisne}
                        showHyndrant={false}
                        height="100%"
                        mapConfig={mapConfig}
                        routeCoordinates={routeData?.polyline}
                        stationGps={stationGps}
                        fitToBounds={hasRoute}
                    />
                </Box>
            )}
            {aktivniPoplach.casVyhlaseni && (
                <Vyjezd2026CasovkaOverlay
                    casVyhlaseni={aktivniPoplach.casVyhlaseni}
                    casVyjezdMinuty={casVyjezdMinuty}
                />
            )}
        </Box>
    );
};
